import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';


interface IStyleProps {
  seeMore?: boolean;
  rotationValue?: string;
}

export const Root = styled.div`
  padding: 0px 103px;
`;

export const PlataformsContainer = styled.div`
  width: 100%;
  display: flex;
  grid-gap: 26px 21px;
  justify-content: center;
  position: relative;
  flex-wrap: wrap;
  margin-top: 86px;
  margin-bottom: 31px;
  max-height: ${(props: IStyleProps) => (props.seeMore ? '' : '115px')};
  overflow: hidden;
`;

export const SeeMoreContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 0px 0px 53px 0px;
  align-items: center;
  justify-content: center;
`;

export const Label = styled.label`
  font-family: Rubik;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
  cursor: pointer;
`;

export const EditIconContainer = styled.div`
  cursor: pointer;
  position: absolute;
  top: 23px;
  right: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  &:hover {
    background-color: rgba(18, 36, 66, 0.05);
  }
`;

export const RotateIcon = styled.div`
    transform: ${(props: IStyleProps) => props.rotationValue ? props.rotationValue : '-100vw'};
    transition: transform 0.4s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`

export const Warning = styled.div`
  position: absolute;
  font-family: Rubik;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #b7332b;
  top: 25px;
  left: 34px;
`;

export const Empty = styled.div`
  position: relative;
  width: 454px;
  height: 101px;
  border-radius: 10px;
  border: solid 1px #bdbdbd;
  background-color: #fff;
  display: flex;
`;